import { render } from "./vaccount.vue?vue&type=template&id=65aaac4c&scoped=true"
import script from "./vaccount.vue?vue&type=script&lang=js"
export * from "./vaccount.vue?vue&type=script&lang=js"

import "./vaccount.vue?vue&type=style&index=0&id=65aaac4c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65aaac4c"]])

export default __exports__